import { lazy } from "react";

const MapScreem = lazy(() =>
  import(/* webpackChunkName: "MapScrem"*/ "../components/mapScreem/MapScreem")
);
const Timings = lazy(() =>
  import(/* webpackChunkName: "TimingScreem"*/ "../components/timing/Timings")
);
const ScreemDriverTiming = lazy(() =>
  import(
    /* webpackChunkName: "ScreemDriverTiming"*/ "../components/driverTiming/ScreemDriverTiming"
  )
);
const Orders = lazy(() =>
  import(/* webpackChunkName: "Orders"*/ "../components/order/Orders")
);
const Drivers = lazy(() =>
  import(/* webpackChunkName: "Drivers"*/ "../components/driver/Drivers")
);
const Reclamo = lazy(() =>
  import(/* webpackChunkName: "Reclamo"*/ "../components/reclamo/Reclamo")
);
const Analityc = lazy(() =>
  import(/* webpackChunkName: "Analityc"*/ "../components/analityc/Analityc")
);
const CalendarTiming = lazy(() =>
  import(
    /* webpackChunkName: "CalendarTiming"*/ "../components/calendarTiming/CalendarTiming"
  )
);
const TurnWeekPage = lazy(() =>
  import(
    /* webpackChunkName: "TurnWeekPage"*/ "../components/turnsWeek/TurnWeekPage"
  )
);
const TimingByDate = lazy(() =>
  import(
    /* webpackChunkName: "TimingByDate"*/ "../components/timingByDate/TimingByDate"
  )
);
const Zone = lazy(() =>
  import(/* webpackChunkName: "Zone"*/ "../components/zone/Zone")
);
const Merchant = lazy(() =>
  import(/* webpackChunkName: "Merchant"*/ "../components/merchant/Merchant")
);
const Banner = lazy(() =>
  import(/* webpackChunkName: "Banner"*/ "../components/banner-driver/Banner")
);
const Report = lazy(() =>
  import(/* webpackChunkName: "Report"*/ "../components/ExecutiveReport/Report")
);
const QuickDrop = lazy(() =>
  import(/* webpackChunkName: "QuickDrop"*/ "../components/quickdrop/QuickDrop")
);
const OrdersByHours = lazy(() =>
  import(
    /* webpackChunkName: "OrdersByHours"*/ "../components/ordersByyHours/OrdersByHours"
  )
);
const MerchantDetails = lazy(() =>
  import(
    /* webpackChunkName: "MerchantDetails"*/ "../components/merchantDetails/MerchatDetails"
  )
);
const Item = lazy(() =>
  import(/* webpackChunkName: "Item"*/ "../components/item/Item")
);
const OpeningHours = lazy(() =>
  import(
    /* webpackChunkName: "OpeningHours"*/ "../components/openingHours/OpeningHours"
  )
);

const Offer = lazy(() =>
  import(/* webpackChunkName: "Offer"*/ "../components/offert/Offert")
);

const Fare = lazy(() =>
  import(/* webpackChunkName: "Fare"*/ "../components/fare/Fare")
);

const FareDetail = lazy(() =>
  import(/* webpackChunkName: "Fare"*/ "../components/fareDetail/FareDetail")
);

const MerchantLocation = lazy(() =>
  import(
    /* webpackChunkName: "MerchantLocation"*/ "../components/merchantLocation/MerchantLocation"
  )
);

const MerchantConfig = lazy(() =>
  import(
    /* webpackChunkName: "MerchantConfig"*/ "../components/merchantConfig/MerchantConfig"
  )
);

const Coverage = lazy(() =>
  import(
    /* webpackChunkName: "Coverage"*/ "../components/coverage/Coverage.jsx"
  )
);

const DriversWallet = lazy(() =>
  import(
    /* webpackChunkName: "Drivers"*/ "../components/driver-wallet/DriverWallet.jsx"
  )
);

const Coupons = lazy(() =>
  import(/* webpackChunkName: "Drivers"*/ "../components/coupon/Coupon.jsx")
);

const CouponsUser = lazy(() =>
  import(
    /* webpackChunkName: "Drivers"*/ "../components/coupon-users/CouponUser.jsx"
  )
);
const HeatMap = lazy(() =>
  import(
    /* webpackChunkName: "HeatMapOrders"*/ "../components/heat-map/HeatMap.jsx"
  )
);

const HeatMapQuote = lazy(() =>
  import(
    /* webpackChunkName: "HeatMapQuote"*/ "../components/heatmap-quote/HeatMapQuote.jsx"
  )
);

const MapZipCode = lazy(() =>
  import(
    /* webpackChunkName: "MapZipCode"*/ "../components/mapZipcode/MapZipCode.jsx"
  )
);

const FeedBack = lazy(() =>
  import(
    /* webpackChunkName: "Feedback"*/ "../components/feedback/Feedback.jsx"
  )
);

const ProductOffers = lazy(
  () =>
    import(
      /* webpackChunkName: "productOffers" */ "../components/productOffer/ProductOfferts.jsx"
    )
  //src\components\productOffer\ProductOffers.jsx
);

const MerchantsHomeApp = lazy(() =>
  import(
    /* webpackChunkName: "merchantsHomeApp" */ "../components/merchantsHomeApp/MerchantsHomeApp.jsx"
  )
);

const UploadImage = lazy(() =>
  import(
    /* webpackChunkName: "uploadImage" */ "../components/uploadImage/UploadImage.jsx"
  )
);
const MerchantVehicleType = lazy(() =>
  import(
    /* webpackChunkName: "merchantVehicleType" */ "../components/merchantVehicleType/MerchantVehicleType.jsx"
  )
);

const ControlCost = lazy(() =>
  import(
    /* webpackChunkName: "controlCost" */ "../components/controlCost/ControlCost.jsx"
  )
);

export const routes = [
  {
    to: "/map-screem",
    path: "map-screem",
    Component: MapScreem,
    name: "Main - Map",
    icon: "fa-solid fa-house",
    omit: false,
  },
  {
    to: "/timigs",
    path: "timigs",
    Component: Timings,
    name: "Timig",
    icon: "fa-solid fa-clock",
    omit: false,
  },
  {
    to: "/driver-timigs",
    path: "driver-timigs",
    Component: ScreemDriverTiming,
    name: "Driver-Timig",
    icon: "fa-solid fa-users",
    omit: false,
  },
  {
    to: "/orders",
    path: "orders",
    Component: Orders,
    name: "Orders",
    icon: "fa-solid fa-arrow-down-short-wide",
    omit: false,
  },
  {
    to: "/drivers",
    path: "drivers",
    Component: Drivers,
    name: "Drivers",
    icon: "fa-solid fa-motorcycle",
    omit: false,
  },
  {
    to: "/drivers-wallet",
    path: "driversWallet",
    Component: DriversWallet,
    name: "Drivers Wallet",
    icon: "fa-solid fa-credit-card-alt",
    omit: false,
  },
  {
    to: "/reclamo",
    path: "reclamo",
    Component: Reclamo,
    name: "Reclamos",
    icon: "fa-solid fa-head-side-cough",
    omit: false,
  },
  {
    to: "/analityc",
    path: "analityc",
    Component: Analityc,
    name: "Analityc",
    icon: "fa-solid fa-chart-line",
    omit: false,
  },
  {
    to: "/calendar",
    path: "calendar",
    Component: CalendarTiming,
    name: "Calendar",
    icon: "fa-solid fa-calendar-days",
    omit: false,
  },
  {
    to: "/ordersByHour",
    path: "ordersByHour",
    Component: OrdersByHours,
    name: "Order by Hours",
    icon: "fa-solid fa-gear",
    omit: false,
  },
  {
    to: "/turnsWeek",
    path: "turnsWeek",
    Component: TurnWeekPage,
    name: "Turns Week",
    icon: "fa-solid fa-calendar-week",
    omit: false,
  },
  {
    to: "/timingByDate:day",
    path: "timingByDate/:day",
    Component: TimingByDate,
    name: "Turnos por dia",
    icon: "fa-solid fa-calendar-days",
    omit: true,
  },
  {
    to: "/zone",
    path: "zone",
    Component: Zone,
    name: "Zone",
    icon: "fa-solid fa-map",
    omit: false,
  },
  {
    to: "/merchants",
    path: "merchants",
    Component: Merchant,
    name: "Merchant",
    icon: "fa-solid fa-store",
    omit: false,
  },
  {
    to: "/merchants-app",
    path: "merchants-app",
    Component: MerchantsHomeApp,
    name: "Merchants Home App",
    icon: "fa-solid fa-store",
    omit: false,
  },
  {
    to: "/merchantDetails/:id",
    path: "/merchantDetails/:id",
    Component: MerchantDetails,
    name: "MerchantDetails",
    icon: "fa-solid fa-store",
    omit: true,
  },
  {
    to: "/merchantLocation",
    path: "/merchantLocation",
    Component: MerchantLocation,
    name: "Merchant Location",
    icon: "fa-solid fa-map-location-dot",
    omit: false,
  },
  {
    to: "/merchantConfig",
    path: "/merchantConfig",
    Component: MerchantConfig,
    name: "Merchant Config",
    icon: "fa-solid fa-gears",
    omit: false,
  },
  {
    to: "/item/:id/:productId/:requiredSku?",
    path: "/item/:id/:productId/:requiredSku?",
    Component: Item,
    name: "MerchantItem",
    icon: "fa-solid fa-store",
    omit: true,
  },
  {
    to: "/openingHours/:id",
    path: "/openingHours/:id",
    Component: OpeningHours,
    name: "MerchantItem",
    icon: "fa-solid fa-store",
    omit: true,
  },
  {
    to: "/banner",
    path: "banner",
    Component: Banner,
    name: "Banners",
    icon: "fa fa-note-sticky",
    omit: false,
  },
  {
    to: "/report",
    path: "report",
    Component: Report,
    name: "Executive-report",
    icon: "fa-solid fa-chart-bar",
    omit: false,
  },
  {
    to: "/customer",
    path: "customer",
    Component: QuickDrop,
    name: "Customers",
    icon: "fa-solid fa-users",
    omit: false,
  },
  {
    to: "/offerts",
    path: "offerts",
    Component: Offer,
    name: "Offerts",
    icon: "fa-solid fa-tag",
    omit: false,
  },
  {
    to: "/productOffer",
    path: "productOffer",
    Component: ProductOffers,
    name: "Product Offers",
    icon: "fa-solid fa-percent",
    omit: false,
  },
  {
    to: "/fares",
    path: "fares",
    Component: Fare,
    name: "Fare structure",
    icon: "fa-solid fa-list-ul",
    omit: false,
  },
  {
    to: "/fare-detail/:id",
    path: "fare-detail",
    Component: FareDetail,
    name: "Fare details",
    icon: "fa-solid fa-list-ul",
    omit: true,
  },
  {
    to: "/coverage",
    path: "coverage",
    Component: Coverage,
    name: "Coverage",
    icon: "fa fa-draw-polygon",
    omit: false,
  },
  {
    to: "/coupons",
    path: "coupons",
    Component: Coupons,
    name: "Coupons",
    icon: "fa-solid fa-receipt",
    omit: false,
  },
  {
    to: "/coupons-users",
    path: "coupons-users",
    Component: CouponsUser,
    name: "Coupons Users",
    icon: "fa-solid fa-receipt",
    omit: false,
  },
  {
    to: "/heat-map",
    path: "heat-map",
    Component: HeatMap,
    name: "HeatMap Orders",
    icon: "fa-solid fa-map",
    omit: false,
  },
  {
    to: "/heatmap-quote",
    path: "heatmap-quote",
    Component: HeatMapQuote,
    name: "HeatMap Quotes",
    icon: "fa-solid fa-map",
    omit: false,
  },
  {
    to: "/map-zipcode",
    path: "map-zipcode",
    Component: MapZipCode,
    name: "Map ZipCode",
    icon: "fa-solid fa-draw-polygon",
    omit: false,
  },
  {
    to: "/feedback",
    path: "feedback",
    Component: FeedBack,
    name: "Feedback",
    icon: "fa-solid fa-bug",
    omit: false,
  },
  {
    to: "/upload-image",
    path: "upload-image",
    Component: UploadImage,
    name: "Upload Image",
    icon: "fa-solid fa-image",
    omit: false,
  },
  {
    to: "/merchantVehicleType/:id",
    path: "/merchantVehicleType/:id",
    Component: MerchantVehicleType,
    name: "MerchantVehicleType",
    icon: "fa-solid fa-store",
    omit: true,
  },
  {
    to: "/control-cost/",
    path: "/control-cost/",
    Component: ControlCost,
    name: "Control Cost",
    icon: "fa-solid fa-money-bill",
    omit: false,
  },
];
